<template>
	<div class="my-customer-page">
		<!-- 无权限保护 -->
		<div v-if="!isBizSales" class="mc-forbidden">
			<i class="el-icon-lock"></i>
			<div class="fb-title">无权访问</div>
			<div class="fb-tip">我的客户仅对业务员/管理员开放。</div>
		</div>

		<template v-else>
			<!-- 页面级 Tab：我的客户 / 我的客情统计 -->
			<div class="mc-pagetabs">
				<div class="mc-pagetab" :class="{active: pageTab === 'customer'}" @click="pageTab = 'customer'">
					<i class="el-icon-user-solid"></i> 我的客户
				</div>
				<div class="mc-pagetab" :class="{active: pageTab === 'kq'}" @click="switchToKq">
					<i class="el-icon-data-analysis"></i> 我的客情统计
				</div>
				<!-- coiai优惠券管理：仅管理员可见 -->
				<div v-if="isAdmin && configStore.features.coiai" class="mc-pagetab" :class="{active: pageTab === 'coupon'}" @click="pageTab = 'coupon'">
					<i class="el-icon-present"></i> coiai优惠券管理
				</div>
			</div>

			<template v-if="pageTab === 'customer'">
				<!-- 顶部统计卡 -->
				<div class="mc-cards">
				<div class="mc-card">
					<div class="mc-label">客户总数</div>
					<div class="mc-value">{{ stats.total || 0 }}</div>
				</div>
				<div class="mc-card mc-dealt">
					<div class="mc-label">成交客户</div>
					<div class="mc-value">{{ stats.dealt || 0 }}</div>
				</div>
				<div class="mc-card mc-undealt">
					<div class="mc-label">未成交客户</div>
					<div class="mc-value">{{ stats.undealt || 0 }}</div>
				</div>
				<div class="mc-card mc-a">
					<div class="mc-label">A级</div>
					<div class="mc-value">{{ stats.a || 0 }}</div>
				</div>
				<div class="mc-card mc-b">
					<div class="mc-label">B级</div>
					<div class="mc-value">{{ stats.b || 0 }}</div>
				</div>
				<div class="mc-card mc-c">
					<div class="mc-label">C级</div>
					<div class="mc-value">{{ stats.c || 0 }}</div>
				</div>
				<div class="mc-card mc-d">
					<div class="mc-label">D级</div>
					<div class="mc-value">{{ stats.d || 0 }}</div>
				</div>
				<div class="mc-card mc-none">
					<div class="mc-label">未分级</div>
					<div class="mc-value">{{ stats.ungraded || 0 }}</div>
				</div>
				<div class="mc-card mc-tx">
					<div class="mc-label">同行</div>
					<div class="mc-value">{{ stats.tongxing || 0 }}</div>
				</div>
				<div v-if="stats.custom" class="mc-card mc-custom">
					<div class="mc-label">自定义等级</div>
					<div class="mc-value">{{ stats.custom || 0 }}</div>
				</div>
			</div>

			<!-- 成交/未成交 Tab -->
			<div class="mc-tabs">
				<div class="mc-tab" :class="{active: customerTab === 'all'}" @click="switchTab('all')">全部({{ stats.total || 0 }})</div>
				<div class="mc-tab" :class="{active: customerTab === 'dealt'}" @click="switchTab('dealt')">成交({{ stats.dealt || 0 }})</div>
				<div class="mc-tab" :class="{active: customerTab === 'undealt'}" @click="switchTab('undealt')">未成交({{ stats.undealt || 0 }})</div>
			</div>

			<!-- 筛选栏 -->
			<div class="mc-toolbar">
				<span class="mc-title">{{ pageTitle }}</span>
				<div class="mc-filters">
					<el-select v-model="filterLevel" placeholder="等级筛选" size="small" clearable
						style="width:130px" @change="onFilterChange">
						<el-option label="A级" value="A"></el-option>
						<el-option label="B级" value="B"></el-option>
						<el-option label="C级" value="C"></el-option>
						<el-option label="D级" value="D"></el-option>
						<el-option label="同行" value="同行"></el-option>
					</el-select>
					<el-select v-if="isAdmin" v-model="filterSalespersonId" placeholder="全部业务员" size="small"
						clearable filterable style="width:180px" @change="onFilterChange">
						<el-option v-for="s in salespersons" :key="s.id" :label="s.nickName || s.userName" :value="s.id"></el-option>
					</el-select>
					<el-button type="primary" size="small" icon="el-icon-search" :loading="listLoading"
						@click="onFilterChange">查询</el-button>
				</div>
			</div>

			<!-- 客户列表 -->
			<el-table :data="list" size="small" v-loading="listLoading" empty-text="暂无客户数据"
				style="width:100%" border>
				<el-table-column label="客户姓名" min-width="120">
					<template slot-scope="s">
						<span class="mc-name" @click="showDetail(s.row)">{{ s.row.realName || s.row.gateItsNick || '-' }}</span>
					</template>
				</el-table-column>
				<!-- 客户微信：业务员当前微信被封后，靠这一列把老客户逐个加回来 -->
				<el-table-column label="客户微信" min-width="180">
					<template slot-scope="s">
						<template v-if="wechatEdit.id === s.row.id">
							<div class="mc-wedit">
								<el-input v-model="wechatEdit.wechatId" size="mini" placeholder="微信号" style="width:100px"></el-input>
								<el-input v-model="wechatEdit.wechatNick" size="mini" placeholder="备注名" style="width:80px"></el-input>
								<el-button type="success" size="mini" icon="el-icon-check" @click="saveWechat(s.row)"></el-button>
								<el-button size="mini" icon="el-icon-close" @click="cancelWechatEdit"></el-button>
							</div>
						</template>
						<template v-else>
							<span v-if="s.row.wechatId" class="mc-wechat" @click="copyWechat(s.row.wechatId)" title="点击复制">{{ s.row.wechatId }}</span>
							<span v-else class="mc-wechat-miss">未填</span>
							<span v-if="s.row.wechatNick" class="mc-wechat-nick">({{ s.row.wechatNick }})</span>
							<el-button type="text" size="mini" class="mc-wbtn" icon="el-icon-edit" @click="startWechatEdit(s.row)"></el-button>
							<el-button v-if="s.row.wechatId" type="text" size="mini" class="mc-wbtn" icon="el-icon-document-copy" @click="copyWechat(s.row.wechatId)"></el-button>
						</template>
					</template>
				</el-table-column>
				<!-- 客户手机号：从该客户全部订单的买家手机号聚合去重(2026-08-19) -->
				<el-table-column label="手机号" min-width="140">
					<template slot-scope="s">
						<template v-if="s.row.phones && s.row.phones.length">
							<span v-for="p in s.row.phones" :key="p" class="mc-phone" @click="copyPhone(p)" title="点击复制">{{ p }}</span>
						</template>
						<span v-else class="mc-wechat-miss">-</span>
					</template>
				</el-table-column>
				<!-- 等级:A/B/C/D/同行/自定义(自定义仅填写人本人可改,后端校验) -->
				<el-table-column label="等级" width="150">
					<template slot-scope="s">
						<div v-if="levelCustomEdit.id === s.row.id" class="mc-wedit">
							<el-input v-model="levelCustomEdit.value" size="mini" placeholder="填写自定义等级" style="width:110px"
								maxlength="10" @keyup.enter.native="saveLevelCustom(s.row)"></el-input>
							<el-button type="success" size="mini" icon="el-icon-check" @click="saveLevelCustom(s.row)"></el-button>
							<el-button size="mini" icon="el-icon-close" @click="cancelLevelCustomEdit"></el-button>
						</div>
						<el-select v-else v-model="s.row.level" size="mini" clearable placeholder="未分级"
							style="width:130px" @change="onLevelChange(s.row)">
							<el-option label="A级" value="A"></el-option>
							<el-option label="B级" value="B"></el-option>
							<el-option label="C级" value="C"></el-option>
							<el-option label="D级" value="D"></el-option>
							<el-option label="同行" value="同行"></el-option>
							<el-option v-if="isCustomLevel(s.row.level)" :label="s.row.level" :value="s.row.level"></el-option>
							<el-option label="＋自定义" value="__custom__"></el-option>
						</el-select>
					</template>
				</el-table-column>
				<el-table-column label="订单数" width="80" prop="orderCount" align="center"></el-table-column>
				<el-table-column label="成交" width="60" prop="dealtCount" align="center"></el-table-column>
				<el-table-column label="累计金额" min-width="120" align="right">
					<template slot-scope="s">{{ fmtAmount(s.row.totalAmount) }} {{ s.row.fiat || 'CNY' }}</template>
				</el-table-column>
				<el-table-column label="最近订单" width="160">
					<template slot-scope="s">{{ fmtTime(s.row.lastOrderTime) }}</template>
				</el-table-column>
				<el-table-column v-if="isAdmin" label="业务员" width="100" prop="salespersonName"></el-table-column>
				<!-- 备注:业务员自己维护(如客户情况/跟进记录),内联编辑 -->
				<el-table-column label="备注" min-width="160">
					<template slot-scope="s">
						<template v-if="remarkEdit.id === s.row.id">
							<div class="mc-wedit">
								<el-input v-model="remarkEdit.value" size="mini" placeholder="填写备注" style="width:140px"
									maxlength="200" @keyup.enter.native="saveRemark(s.row)"></el-input>
								<el-button type="success" size="mini" icon="el-icon-check" @click="saveRemark(s.row)"></el-button>
								<el-button size="mini" icon="el-icon-close" @click="cancelRemarkEdit"></el-button>
							</div>
						</template>
						<template v-else>
							<span class="mc-remark" :title="s.row.remark || ''">{{ s.row.remark || '-' }}</span>
							<el-button type="text" size="mini" class="mc-wbtn" icon="el-icon-edit" @click="startRemarkEdit(s.row)"></el-button>
						</template>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="80" align="center">
					<template slot-scope="s">
						<el-button type="text" size="mini" @click="showDetail(s.row)">详情</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 客户详情弹窗 -->
			<el-dialog title="客户详情" :visible.sync="detailDialog.visible" width="720px" append-to-body
				custom-class="mc-detail-dialog">
				<div v-loading="detailDialog.loading" class="mc-detail">
					<div v-if="detailDialog.data" class="mc-detail-body">
						<!-- 客户基本信息卡片 -->
						<div class="mc-customer-card">
							<div class="mc-customer-header">
								<span class="mc-customer-name">{{ detailDialog.data.realName || detailDialog.data.gateItsNick || '-' }}</span>
								<el-tag :type="levelTagType(detailDialog.data.level)"
									:effect="detailDialog.data.level === 'A' ? 'dark' : 'light'" size="small">
									{{ levelText(detailDialog.data.level) }}
								</el-tag>
							</div>
							<div class="mc-customer-grid">
								<div class="mc-info-item">
									<span class="mc-info-label">对手方</span>
									<span class="mc-info-value">{{ detailDialog.data.gateItsNick || '-' }}</span>
								</div>
								<!-- 微信号：换微信后找回客户的唯一凭据，未填时标红提醒补齐 -->
								<div class="mc-info-item">
									<span class="mc-info-label">客户微信</span>
									<span class="mc-info-value" :class="{ 'mc-wechat-miss': !detailDialog.data.wechatId }">
										{{ detailDialog.data.wechatId || '未填' }}
										<template v-if="detailDialog.data.wechatNick">（{{ detailDialog.data.wechatNick }}）</template>
									</span>
								</div>
								<div class="mc-info-item" v-if="detailDialog.data.salespersonName">
									<span class="mc-info-label">业务员</span>
									<span class="mc-info-value">{{ detailDialog.data.salespersonName }}</span>
								</div>
								<!-- 订单聚合手机号(2026-08-19): 全部订单买家手机号去重 -->
								<div class="mc-info-item">
									<span class="mc-info-label">手机号</span>
									<span class="mc-info-value">
										<template v-if="detailDialog.data.phones && detailDialog.data.phones.length">
											<span v-for="p in detailDialog.data.phones" :key="p" class="mc-phone" @click="copyPhone(p)" title="点击复制">{{ p }}</span>
										</template>
										<template v-else>-</template>
									</span>
								</div>
								<div class="mc-info-item" v-if="detailDialog.data.gateItsUid">
									<span class="mc-info-label">UID</span>
									<span class="mc-info-value mc-uid">{{ detailDialog.data.gateItsUid }}</span>
								</div>
								<div class="mc-info-item">
									<span class="mc-info-label">建档时间</span>
									<span class="mc-info-value">{{ fmtTime(detailDialog.data.createdTime) }}</span>
								</div>
							</div>
							<div class="mc-info-remark" v-if="detailDialog.data.remark">
								<span class="mc-info-label">备注</span>
								<span class="mc-info-value">{{ detailDialog.data.remark }}</span>
							</div>
						</div>

						<!-- 关联订单 -->
						<div class="mc-orders-section">
							<div class="mc-orders-title">
								<i class="el-icon-tickets"></i>
								<span>关联订单（{{ (detailDialog.data.orders || []).length }} 笔）</span>
							</div>
							<el-table :data="detailDialog.data.orders || []" size="mini" empty-text="暂无关联订单"
								border style="width:100%">
								<el-table-column label="订单号" prop="orderTxid" min-width="140"></el-table-column>
								<el-table-column label="金额" min-width="100">
									<template slot-scope="s">{{ fmtAmount(s.row.amount) }} {{ s.row.fiat || 'CNY' }}</template>
								</el-table-column>
								<el-table-column label="USDT" width="90" align="right">
									<template slot-scope="s">{{ fmtAmount(s.row.cryptoAmount) }}</template>
								</el-table-column>
								<el-table-column label="状态" width="90" align="center">
									<template slot-scope="s">
										<el-tag :type="flowStatusType(s.row.flowStatus)" size="mini">{{ flowStatusText(s.row.flowStatus) }}</el-tag>
									</template>
								</el-table-column>
								<el-table-column label="业务员" width="80" prop="salespersonName"></el-table-column>
								<el-table-column label="手机号" width="110">
									<template slot-scope="s">
										<span v-if="s.row.buyerPhone" class="mc-phone" @click="copyPhone(s.row.buyerPhone)" title="点击复制">{{ s.row.buyerPhone }}</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
								<el-table-column label="时间" width="140">
									<template slot-scope="s">{{ fmtTime(s.row.createdTime) }}</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>
				<span slot="footer">
					<el-button size="small" @click="detailDialog.visible = false">关闭</el-button>
				</span>
			</el-dialog>
			</template>

			<!-- coiai优惠券管理(Tab页,仅管理员) -->
			<template v-else-if="pageTab === 'coupon'">
				<coi-coupon-manage v-if="isAdmin && configStore.features.coiai"></coi-coupon-manage>
			</template>
			
			<!-- 我的客情统计(Tab页):客情总数 + 每日列表 + 逐日修改 -->
			<template v-else-if="pageTab === 'kq'">
				<div class="kq-panel" v-loading="kqDialog.loading">
					<div class="kq-summary">
						<span class="kq-sum-label">客情总数</span>
						<span class="kq-sum-value">{{ kqDialog.totalFans == null ? '-' : kqDialog.totalFans }}</span>
						<span class="kq-sum-sub">共 {{ kqDialog.total || 0 }} 天填报</span>
						<template v-if="kqDialog.totals && kqDialog.totals.length">
							<span v-for="t in kqDialog.totals" :key="t.name" class="kq-sum-item">{{ t.name }}：{{ t.value }}</span>
						</template>
					</div>
					<div class="kq-tip">客情是自己在客情群填报的数据，和订单客户没有直接联系；点「修改」可调整当天的客情人数状况</div>
					<el-table :data="kqDialog.list" size="small" border empty-text="暂无客情填报记录" style="width:100%">
						<el-table-column label="日期" width="110" prop="date"></el-table-column>
						<el-table-column v-for="f in kqDialog.fields" :key="f.id" :label="f.name" min-width="76" align="center">
							<template slot-scope="s">{{ kqCellValue(s.row, f.id) }}</template>
						</el-table-column>
						<el-table-column label="更新时间" width="140" prop="updatedText"></el-table-column>
						<el-table-column label="操作" width="80" align="center">
							<template slot-scope="s">
								<el-button type="text" size="mini" @click="startKqEdit(s.row)">修改</el-button>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination class="kq-pager" background layout="prev, pager, next" :total="kqDialog.total || 0"
						:page-size="kqDialog.pageSize" :current-page.sync="kqDialog.pageNo" @current-change="loadKqHistory"
						v-if="(kqDialog.total || 0) > kqDialog.pageSize"></el-pagination>
				</div>

				<!-- 修改某天客情:动态字段表单 -->
				<el-dialog :title="'修改客情（' + kqEdit.date + '）'" :visible.sync="kqEdit.visible" width="520px" append-to-body>
					<div class="kq-edit-form">
						<div v-for="f in kqDialog.fields" :key="f.id" class="kq-edit-row">
							<span class="kq-edit-label">{{ f.name }}</span>
							<el-input v-model="kqEdit.content[String(f.id)]" size="small" placeholder="0" style="width:160px"></el-input>
						</div>
					</div>
					<span slot="footer">
						<el-button size="small" @click="kqEdit.visible = false">取消</el-button>
						<el-button type="primary" size="small" :loading="kqEdit.submitting" @click="submitKqEdit">保存</el-button>
					</span>
				</el-dialog>
			</template>
		</template>
	</div>
</template>

<script>
import bizApi from '../api/bizApi.js';
import CoiCouponManage from '../components/customer/CoiCouponManage.vue';

const FLOW_TEXT = {
	'-1': '已取消', 0: '待分配', 1: '待确认收款', 2: '待放行', 3: '已放行', 4: '待财务确认', 5: '完结'
};

export default {
	name: 'my-customer',
	components: { CoiCouponManage },
	data() {
		return {
			stats: {},
			list: [],
			listLoading: false,
			filterLevel: '',
			filterSalespersonId: '',
			salespersons: [],
			detailDialog: { visible: false, data: null, loading: false },
			wechatEdit: { id: null, wechatId: '', wechatNick: '' },
			remarkEdit: { id: null, value: '' },
			levelCustomEdit: { id: null, value: '' },
			customerTab: 'all',
			// 页面级Tab: customer=我的客户, kq=我的客情统计
			pageTab: 'customer',
			// 我的客情统计面板(复用客勤填报接口,仅当前业务员自己的数据)
			kqDialog: {
				loading: false,
				fields: [], list: [], totals: [],
				total: 0, totalFans: null,
				pageNo: 1, pageSize: 20
			},
			kqEdit: { visible: false, date: '', content: {}, submitting: false }
		};
	},
	computed: {
		isBizSales() {
			return this.userStore && this.userStore.isBizSales;
		},
		isAdmin() {
			return this.userStore && this.userStore.isBizAdmin;
		},
		pageTitle() {
			if (!this.isAdmin) return '我的客户';
			if (!this.filterSalespersonId) return '客户管理';
			const sp = this.salespersons.find(s => s.id === this.filterSalespersonId);
			return sp ? (sp.nickName || sp.userName) + '的客户' : '客户管理';
		}
	},
	watch: {
		// bizRole 由异步 me() 写入 userStore，可能晚于本组件 mounted
		isBizSales(val) {
			if (val) {
				this.loadStats();
				this.loadList();
				if (this.isAdmin) this.loadSalespersons();
			}
		}
	},
	mounted() {
		this.initPage();
	},
	methods: {
		async initPage() {
			if (this.isBizSales) {
				this.loadStats();
				this.loadList();
				if (this.isAdmin) this.loadSalespersons();
			} else {
				// 角色可能尚未加载或加载失败，重试一次
				try {
					await this.userStore.loadBizRole();
				} catch (e) {
					console.error('[MyCustomer] retry loadBizRole failed', e);
				}
				if (this.isBizSales) {
					this.loadStats();
					this.loadList();
					if (this.isAdmin) this.loadSalespersons();
				}
			}
		},
		loadStats() {
			const params = {};
			if (this.isAdmin && this.filterSalespersonId) params.salespersonId = this.filterSalespersonId;
			bizApi.customerLevelStats(params).then((d) => {
				this.stats = d || {};
			}).catch(() => { });
		},
		switchTab(tab) {
			this.customerTab = tab;
			this.loadList();
		},
		loadList() {
			this.listLoading = true;
			const params = {};
			if (this.filterLevel) params.level = this.filterLevel;
			if (this.isAdmin && this.filterSalespersonId) params.salespersonId = this.filterSalespersonId;
			if (this.customerTab === 'dealt') params.dealt = true;
			if (this.customerTab === 'undealt') params.dealt = false;
			bizApi.customerMyList(params).then((list) => {
				this.list = list || [];
			}).catch(() => { }).finally(() => { this.listLoading = false; });
		},
		onFilterChange() {
			this.loadStats();
			this.loadList();
		},
		loadSalespersons() {
			bizApi.salespersons().then((list) => {
				this.salespersons = list || [];
			}).catch(() => { });
		},
		startWechatEdit(row) {
			this.wechatEdit = { id: row.id, wechatId: row.wechatId || '', wechatNick: row.wechatNick || '' };
		},
		cancelWechatEdit() {
			this.wechatEdit = { id: null, wechatId: '', wechatNick: '' };
		},
		saveWechat(row) {
			const wechatId = (this.wechatEdit.wechatId || '').trim();
			const wechatNick = (this.wechatEdit.wechatNick || '').trim();
			bizApi.customerUpdateWechat(row.id, wechatId, wechatNick).then(() => {
				row.wechatId = wechatId || null;
				row.wechatNick = wechatNick || null;
				this.$message.success('微信号已更新');
				this.cancelWechatEdit();
			}).catch(() => { });
		},
		// ---------- 客户备注内联编辑(业务员自己维护) ----------
		startRemarkEdit(row) {
			this.remarkEdit = { id: row.id, value: row.remark || '' };
		},
		cancelRemarkEdit() {
			this.remarkEdit = { id: null, value: '' };
		},
		saveRemark(row) {
			const remark = (this.remarkEdit.value || '').trim();
			bizApi.customerUpdateRemark(row.id, remark).then(() => {
				row.remark = remark || null;
				this.$message.success('备注已更新');
				this.cancelRemarkEdit();
			}).catch(() => { });
		},
		copyWechat(text) {
			const ta = document.createElement('textarea');
			ta.value = text;
			ta.style.position = 'fixed';
			ta.style.opacity = '0';
			document.body.appendChild(ta);
			ta.select();
			try { document.execCommand('copy'); this.$message.success('已复制: ' + text); }
			catch (e) { this.$message.warning('复制失败,请手动复制'); }
			document.body.removeChild(ta);
		},
		// 手机号复制(与微信号同一套剪贴板逻辑)
		copyPhone(text) {
			this.copyWechat(text);
		},
		onLevelChange(row) {
			// 选中"自定义"时进入内联填写模式，不直接提交
			if (row.level === '__custom__') {
				this.levelCustomEdit = { id: row.id, value: '' };
				return;
			}
			bizApi.customerUpdateLevel(row.id, row.level || null).then(() => {
				this.$message.success('等级已更新');
				this.loadStats();
			}).catch(() => {
				// 失败后重新加载恢复原值(如:别人的自定义等级被拒)
				this.loadList();
			});
		},
		// ---------- 自定义等级内联填写 ----------
		isCustomLevel(lv) {
			return !!lv && ['A', 'B', 'C', 'D', '同行'].indexOf(lv) === -1;
		},
		levelText(lv) {
			if (!lv) return '未分级';
			if (lv === '同行') return '同行';
			if (['A', 'B', 'C', 'D'].indexOf(lv) >= 0) return lv + '级';
			return lv;
		},
		saveLevelCustom(row) {
			const v = (this.levelCustomEdit.value || '').trim();
			if (!v) { this.$message.warning('请填写自定义等级内容'); return; }
			bizApi.customerUpdateLevel(row.id, v).then(() => {
				row.level = v;
				this.levelCustomEdit = { id: null, value: '' };
				this.$message.success('等级已更新');
				this.loadStats();
			}).catch(() => {
				this.levelCustomEdit = { id: null, value: '' };
				this.loadList();
			});
		},
		cancelLevelCustomEdit() {
			this.levelCustomEdit = { id: null, value: '' };
			// 行内 level 已被改成虚拟值 __custom__，重新拉列表恢复原值
			this.loadList();
		},
		showDetail(row) {
			this.detailDialog.data = null;
			this.detailDialog.visible = true;
			this.detailDialog.loading = true;
			bizApi.customerDetail(row.id).then((d) => {
				this.detailDialog.data = d;
			}).catch(() => { }).finally(() => { this.detailDialog.loading = false; });
		},
		// ---------- 我的客情统计 ----------
		switchToKq() {
			this.pageTab = 'kq';
			this.kqDialog.pageNo = 1;
			this.kqDialog.loading = true;
			const pFields = this.kqDialog.fields.length ? Promise.resolve() : bizApi.kqFields().then((fs) => {
				this.kqDialog.fields = fs || [];
			});
			pFields.then(() => this.loadKqHistory()).catch(() => { }).finally(() => { this.kqDialog.loading = false; });
		},
		loadKqHistory() {
			this.kqDialog.loading = true;
			bizApi.kqReportHistory({ pageNo: this.kqDialog.pageNo, pageSize: this.kqDialog.pageSize }).then((d) => {
				this.kqDialog.total = (d && d.total) || 0;
				this.kqDialog.totalFans = (d && d.myTotalFans !== undefined && d.myTotalFans !== null) ? d.myTotalFans : null;
				const sums = (d && d.myTotals) || {};
				this.kqDialog.totals = Object.keys(sums).filter((k) => k !== '总数').map((k) => ({ name: k, value: sums[k] }));
				this.kqDialog.list = ((d && d.list) || []).map((r) => {
					let obj = {};
					try { obj = JSON.parse(r.content || '{}') || {}; } catch (e) { /* ignore */ }
					return {
						date: this.fmtDate(r.reportDate),
						obj,
						updatedText: (r.updatedTime || '').substring(0, 16)
					};
				});
			}).catch(() => { }).finally(() => { this.kqDialog.loading = false; });
		},
		kqCellValue(row, fieldId) {
			const v = row.obj[String(fieldId)];
			return v === undefined || v === null || v === '' ? '-' : v;
		},
		// 后端 reportDate 是 UTC ISO串,直接截前10位会差一天,按本地时区格式化
		fmtDate(v) {
			const d = new Date(v);
			if (!(d instanceof Date) || isNaN(d)) return (v || '').substring(0, 10);
			const p = (x) => String(x).padStart(2, '0');
			return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
		},
		startKqEdit(row) {
			const content = {};
			this.kqDialog.fields.forEach((f) => {
				const v = row.obj[String(f.id)];
				content[String(f.id)] = (v === undefined || v === null) ? '' : String(v);
			});
			this.kqEdit = { visible: true, date: row.date, content, submitting: false };
		},
		submitKqEdit() {
			if (this.kqEdit.submitting) return;
			this.kqEdit.submitting = true;
			bizApi.kqReportSubmit(this.kqEdit.date, this.kqEdit.content).then(() => {
				this.$message.success('已保存');
				this.kqEdit.visible = false;
				this.loadKqHistory();
			}).catch(() => {
				// http 拦截器已弹出错误提示
			}).finally(() => { this.kqEdit.submitting = false; });
		},
		levelTagType(level) {
			if (level === 'A') return 'warning';
			if (level === 'B') return '';
			if (level === 'C') return 'success';
			if (level === 'D') return 'info';
			if (level === '同行') return 'danger';
			if (level) return 'warning';
			return 'info';
		},
		flowStatusText(s) {
			return FLOW_TEXT[String(s)] || '-';
		},
		flowStatusType(s) {
			s = String(s);
			if (s === '5') return 'success';
			if (s === '-1') return 'info';
			if (s === '3' || s === '4') return 'warning';
			return '';
		},
		fmtAmount(n) {
			if (n == null) return '-';
			return Number(n).toLocaleString('zh-CN', { maximumFractionDigits: 2 });
		},
		fmtTime(t) {
			if (!t) return '-';
			let d;
			if (typeof t === 'number') d = new Date(t);
			else if (typeof t === 'string') d = new Date(t);
			else d = t;
			if (!(d instanceof Date) || isNaN(d)) return '-';
			const p = (x) => String(x).padStart(2, '0');
			return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
		}
	}
};
</script>

<style scoped lang="scss">
.my-customer-page {
	height: 100%;
	overflow-y: auto;
	box-sizing: border-box;
	padding: 16px 20px;

	.mc-forbidden {
		text-align: center;
		padding: 80px 0;
		color: #999;

		i {
			font-size: 48px;
		}

		.fb-title {
			font-size: 18px;
			margin-top: 12px;
		}

		.fb-tip {
			font-size: 13px;
			margin-top: 6px;
		}
	}

	/* 页面级 Tab:我的客户 / 我的客情统计 */
	.mc-pagetabs {
		display: flex;
		gap: 0;
		margin-bottom: 16px;
		border-bottom: 2px solid #e4e7ed;

		.mc-pagetab {
			padding: 10px 24px;
			font-size: 15px;
			font-weight: 500;
			color: #606266;
			cursor: pointer;
			border-bottom: 2px solid transparent;
			margin-bottom: -2px;
			transition: all 0.2s;

			i {
				margin-right: 4px;
			}

			&:hover {
				color: #409eff;
			}

			&.active {
				color: #409eff;
				border-bottom-color: #409eff;
			}
		}
	}

	.mc-cards {
		display: flex;
		gap: 12px;
		margin-bottom: 16px;

		.mc-card {
			flex: 1;
			padding: 14px 16px;
			border-radius: 8px;
			background: #f5f7fa;
			text-align: center;

			.mc-label {
				font-size: 13px;
				color: #909399;
			}

			.mc-value {
				font-size: 24px;
				font-weight: 700;
				margin-top: 4px;
				color: #303133;
			}

			&.mc-dealt {
				background: #f0f9eb;

				.mc-value {
					color: #67c23a;
				}
			}

			&.mc-undealt {
				background: #f4f4f5;

				.mc-value {
					color: #909399;
				}
			}

			&.mc-a {
				background: #fdf6ec;

				.mc-value {
					color: #e6a23c;
				}
			}

			&.mc-b {
				background: #ecf5ff;

				.mc-value {
					color: #409eff;
				}
			}

			&.mc-c {
				background: #f0f9eb;

				.mc-value {
					color: #67c23a;
				}
			}

			&.mc-d {
				background: #f4f4f5;

				.mc-value {
					color: #909399;
				}
			}

			&.mc-none {
				background: #f4f4f5;

				.mc-value {
					color: #c0c4cc;
				}
			}

			&.mc-tx {
				background: #fef0f0;

				.mc-value {
					color: #f56c6c;
				}
			}

			&.mc-custom {
				background: #fdf6ec;

				.mc-value {
					color: #e6a23c;
				}
			}
		}
	}

	.mc-tabs {
		display: flex;
		gap: 4px;
		margin-bottom: 14px;

		.mc-tab {
			padding: 6px 16px;
			border-radius: 4px;
			font-size: 13px;
			cursor: pointer;
			color: #606266;
			background: #f5f7fa;
			transition: all 0.2s;

			&:hover {
				color: #409eff;
			}

			&.active {
				color: #fff;
				background: #409eff;
				font-weight: 500;
			}
		}
	}

	.mc-toolbar {
		display: flex;
		align-items: center;
		margin-bottom: 12px;

		.mc-title {
			font-size: 16px;
			font-weight: 600;
			margin-right: auto;
		}

		.mc-filters {
			display: flex;
			align-items: center;
			gap: 10px;
		}
	}

	.mc-name {
		color: #409eff;
		cursor: pointer;
		font-weight: 500;

		&:hover {
			text-decoration: underline;
		}
	}

	/* 客户微信列：微信绿突出可用，未填标红提醒补齐（未填的单无法回款）*/
	.mc-wechat {
		color: #07c160;
		font-weight: 500;
		word-break: break-all;
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
	}

	/* 订单聚合手机号(2026-08-19): 蓝色可点击复制,多个号码纵向排列 */
	.mc-phone {
		display: inline-block;
		color: #409eff;
		font-weight: 500;
		cursor: pointer;
		margin-right: 6px;
		&:hover {
			text-decoration: underline;
		}
	}

	.mc-wbtn {
		padding: 2px 4px;
		margin-left: 4px;
	}

	.mc-wedit {
		display: flex;
		align-items: center;
		gap: 4px;
	}

	.mc-wechat-nick {
		color: #909399;
		font-size: 12px;
		margin-left: 4px;
	}

	.mc-wechat-miss {
		color: #f56c6c;
	}

	.mc-remark {
		color: #606266;
		word-break: break-all;
	}

	/* 我的客情统计面板 */
	.kq-panel {
		.kq-summary {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			gap: 6px 14px;
			padding: 10px 14px;
			margin-bottom: 10px;
			background: #f5f7fa;
			border-radius: 6px;
			font-size: 13px;
			color: #606266;

			.kq-sum-label {
				color: #909399;
			}

			.kq-sum-value {
				font-size: 22px;
				font-weight: 700;
				color: #e6a23c;
				line-height: 1;
			}

			.kq-sum-sub {
				color: #909399;
			}

			.kq-sum-item {
				color: #606266;
			}
		}

		.kq-tip {
			font-size: 12px;
			color: #909399;
			margin-bottom: 8px;
		}

		.kq-pager {
			margin-top: 10px;
			text-align: right;
		}
	}
}
</style>

<!-- 详情弹窗样式(非 scoped, 因为 dialog 渲染在 body) -->
<style lang="scss">
.mc-detail-dialog {
	.mc-detail {
		min-height: 80px;
	}

	.mc-detail-body {
		/* 客户信息卡片 */
		.mc-customer-card {
			background: #f5f7fa;
			border-radius: 8px;
			padding: 16px 20px;
			margin-bottom: 16px;

			.mc-customer-header {
				display: flex;
				align-items: center;
				gap: 12px;
				margin-bottom: 14px;
				padding-bottom: 12px;
				border-bottom: 1px solid #e4e7ed;

				.mc-customer-name {
					font-size: 18px;
					font-weight: 600;
					color: #303133;
				}
			}

			.mc-customer-grid {
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 10px 24px;

				.mc-info-item {
					display: flex;
					align-items: center;
					font-size: 13px;

					.mc-info-label {
						width: 70px;
						color: #909399;
						flex-shrink: 0;
					}

					.mc-info-value {
						color: #303133;

						&.mc-uid {
							font-family: 'Courier New', monospace;
							font-size: 12px;
							word-break: break-all;
						}

						/* 微信未填：标红，这种客户的订单无法回款 */
						&.mc-wechat-miss {
							color: #f56c6c;
						}
					}
				}
			}

			.mc-info-remark {
				display: flex;
				align-items: flex-start;
				margin-top: 10px;
				padding-top: 10px;
				border-top: 1px dashed #e4e7ed;
				font-size: 13px;

				.mc-info-label {
					width: 70px;
					color: #909399;
					flex-shrink: 0;
				}

				.mc-info-value {
					color: #303133;
				}
			}
		}

		/* 关联订单区域 */
		.mc-orders-section {
			.mc-orders-title {
				font-size: 14px;
				font-weight: 600;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				gap: 6px;
				color: #303133;

				i {
					color: #409eff;
				}
			}
		}
	}
}

/* 修改客情表单(弹窗渲染在 body,非 scoped) */
.kq-edit-form {
	max-height: 420px;
	overflow-y: auto;

	.kq-edit-row {
		display: flex;
		align-items: center;
		margin-bottom: 12px;

		.kq-edit-label {
			width: 110px;
			flex-shrink: 0;
			font-size: 13px;
			color: #606266;
		}
	}
}
</style>
